export default __webpack_public_path__ + "static/media/heimdall-silver.859314ab.png";